import { Maybe } from '@csp/csp-common-model';
import { RpmMonitoringContentModel, RpmNoticeContentModel } from '@csp/csp-web-content-definitions';

const getTitleByModuleCode = (moduleCode: string, rpmMonitoringContent: RpmMonitoringContentModel): string => {
  const title = rpmMonitoringContent?.rpm_module?.find(module => module.rpm_module?.algorithm_code === moduleCode)
    ?.rpm_module?.header;

  return title?.trim() || moduleCode;
};

const getTitleByIdentifier = (
  identifier: Maybe<string>,
  rpmNoticeContent: RpmNoticeContentModel[],
  defaultValue = identifier,
): Maybe<string> => {
  const title = rpmNoticeContent.find(notice => notice.content_code === identifier)?.page_title;

  return title?.trim() || defaultValue;
};

const getTitleByFormulaCode = (formulaCode: string, rpmMonitoringContent: RpmMonitoringContentModel): string => {
  const title = rpmMonitoringContent.rpm_module?.find(module => module.rpm_module?.algorithm_code === formulaCode)
    ?.rpm_module?.header;

  return title?.trim() || formulaCode;
};

const getTitleByIdentifierOrFormulaCode = (
  identifierOrFormulaCode: string,
  rpmMonitoringContent: RpmMonitoringContentModel,
  rpmNoticeContent: RpmNoticeContentModel[],
): string => {
  const title = getTitleByIdentifier(identifierOrFormulaCode, rpmNoticeContent, '');

  return title || getTitleByFormulaCode(identifierOrFormulaCode, rpmMonitoringContent);
};

export const RpmEventContentUtil = {
  getTitleByModuleCode,
  getTitleByIdentifier,
  getTitleByFormulaCode,
  getTitleByIdentifierOrFormulaCode,
};
